module.exports = __webpack_public_path__ + "static/media/linkedin-social-media-svgrepo-com (1).45a676a2.svg";